import { AUTOALBUM, AUTOALBUM_ORIG_NAME } from '@disco/constants/PlaylistTypes'

/**
 * Finds the ID of the album playlist type from an array of playlist types.
 *
 * Searches for a playlist type with the name matching either AUTOALBUM or AUTOALBUM_ORIG_NAME
 * constants from the PlaylistTypes module.
 *
 * @param playlistTypes - Array of playlist type objects with name and id properties
 * @returns The ID of the album playlist type if found, null otherwise
 */
export function getAlbumPlaylistId(
  playlistTypes: {
    name: string
    id: number
  }[],
): number | null | undefined {
  const playlistType = playlistTypes.find(
    t => t.name === AUTOALBUM || t.name === AUTOALBUM_ORIG_NAME,
  )
  return playlistType ? playlistType.id : null
}
